module.exports = __webpack_public_path__ + "/images/cover-onboading-guest-screenshot-vertical.4814953.png";